import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Button as BootstrapButton, FormGroup } from "react-bootstrap";
import styles from "./Button.scss";

class Button extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var formGroupClass = classNames({
      [styles.noMarginBottom]: this.props.noMarginBottom
    });
    var btnClass = classNames({
      [styles.button]: true,
      [styles.primary]:
        this.props.isPrimary && !this.props.isCompany && !this.props.isBlue,
      [styles.companyPrimary]: this.props.isPrimary && this.props.isCompany,
      [styles.secondary]: this.props.isSecondary,
      [styles.blue]: this.props.isBlue,
      [styles.small]: this.props.isSmall,
      [styles.verySmall]: this.props.isVerySmall,
      [styles.buttonRelative]: this.props.relative
    });
    return (
      <FormGroup className={formGroupClass}>
        <BootstrapButton
          id={this.props.id}
          className={btnClass}
          disabled={this.props.isDisabled}
          onClick={this.props.onClick}
          type={this.props.type}
        >
          {this.props.isLoading ? this.props.loadingText : this.props.label}
        </BootstrapButton>
      </FormGroup>
    );
  }
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isPrimary: PropTypes.bool,
  isCompany: PropTypes.bool,
  isSecondary: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSmall: PropTypes.bool,
  isLoading: PropTypes.bool,
  isBlue: PropTypes.bool,
  loadingText: PropTypes.string
};

Button.defaultProps = {
  isPrimary: true,
  isSecondary: false,
  isDisabled: false,
  type: "button",
  isCompany: false,
  isSmall: false,
  isLoading: false,
  isBlue: false,
  loadingText: ""
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/button/Button.js